import axios from "axios";
import { ENDPOINTS } from "./_config";

export const getCalendarSlotStartTime = async (recruiterID, setSlots, setSlotLoader) => {
  const url = `${ENDPOINTS.CALENDAR.MICROSOFT_CALENDAR_SLOTS}${recruiterID}`;
  setSlotLoader(true)
  try {
    const response = await axios.get(url);
    setSlots(response.data.data); // Set response to state
  } catch (error) {
  }
  setSlotLoader(false)
};


export const postCalendarEvent = async ({ patientTrialJuncID, recruiterID, eventTime }, addToast) => {
  try {
    const response = await axios.post(
      ENDPOINTS.CONVERSATION.CREATE_EVENT,
      {
        patientTrialJuncID,
        recruiterID,
        eventTime
      },
      {
        headers: {
          'Content-Type': 'application/json-patch+json',
          'Accept': 'text/plain'
        }
      }
    );
    addToast("Event added successfully to the calendar.", "success")
    return response.data;
  } catch (error) {
    addToast(error.response?.data.message || error.message, "error")
    console.error('Error posting calendar event:', error.response?.data.message || error.message);
    return null;
  }
};

export const getTrialById = async (data) => {
  try {
    const response = await axios.get(`${ENDPOINTS.TRIALS.GET_TRIAL_BY_ID}?TrialID=${data.id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching trial by ID:', error);
    throw error;
  }
};